module.exports = __webpack_public_path__ + "static/media/bbc_news_live_election-us-2016-37899679_plot.739f0be3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_election-us-2016-37899679_plot.png
// module id = 351
// module chunks = 0